import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import store from '../store/index';
window.pusher = require('pusher-js');
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '4cc9ef3e6dadd32cd0bc',
  encrypt: true,
  cluster: 'eu'
});

const getnotificationForEmployee = function() {
  window.Echo.channel('notification').listen(
    '.employee_' + store.state.User.id,
    function(e) {
      var newNotification = e.notif;
      store.commit('NEW_NOTIFICATION', newNotification);
    }
  );
};
const destroyed = function() {
  window.Echo.leave('notification');
};
export default {
  getnotificationForEmployee,
  destroyed
};
